import { useState, useEffect } from "react";
import SuccessScreen from "../SuccessScreen/SuccessScreen";
import FailureScreen from "../FailureScreen/FailureScreen";

const LeadFinderScreen = ({ checkPayments_Stripe }) => {
  const [successScreen, setSuccessScreen] = useState(null);
  useEffect(() => {
    if (checkPayments_Stripe === "true") {
      setSuccessScreen(true);
    } else {
      setSuccessScreen(false);
    }
  }, [checkPayments_Stripe]);

  return <>{successScreen ? <SuccessScreen /> : <FailureScreen />}</>;
};
export default LeadFinderScreen;
